'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, event_id, adj_id, person_id) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({
      feis_id: feis_id,
      event_id: event_id,
      adj_id: adj_id,
      person_id: person_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.dressCheckForPersonAndAdjUrl)(feis_id, event_id, adj_id, person_id),
        method: 'DELETE'
      },
      types: ['DELETE_DRESS_CHECK_START', 'DELETE_DRESS_CHECK', 'DELETE_DRESS_CHECK_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/dress-checks/deleteDressCheck.js
// module id = 150
// module chunks = 0